module.exports = __webpack_public_path__ + "static/media/STAF_bokmål og nordsamisk_primærlogo_pos(svart).c4b1a885.png";